module.exports = __webpack_public_path__ + "img/20190826133549360截图20190824150207476.bd98fca4.jpg";